import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import WelcomeHeader from 'pages/WelcomePage/components/WelcomeHeader/WelcomeHeader';
import LeftSidebar from 'components/LeftSidebar/LeftSidebar';
import MobileBottomNav from 'components/MobileBottomNav/MobileBottomNav';
import FloatingDecorations from 'components/FloatingDecorations/FloatingDecorations';
import CookieBanner from 'components/CookieBanner/CookieBanner';
import styles from 'pages/WelcomePage/WelcomePage.module.scss';

const COLLAPSED_WIDTH = 68;
const EXPANDED_WIDTH = 272;
const SIDEBAR_MARGIN = 10; // left margin of the sidebar

const MainLayout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  const sidebarWidth = sidebarExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleMenuClick = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handlePlusClick = () => {
    // Toggle the plus menu in App.js via window event
    window.dispatchEvent(new Event('toggleMobilePlusMenu'));
  };

  const handleLoginClick = () => {
    setAuthOpen(true);
  };

  return (
    <div
      className={styles.wrapper}
      style={{ '--sidebar-offset': isMobile ? '0px' : `${sidebarWidth + SIDEBAR_MARGIN}px` }}
    >
      <FloatingDecorations />
      <LeftSidebar 
        expanded={sidebarExpanded} 
        onToggle={() => setSidebarExpanded(v => !v)} 
        fullScreenMobile={mobileMenuOpen}
        onCloseMobile={() => setMobileMenuOpen(false)}
      />

      <div
        className={styles.mainArea}
        style={{ 
          marginLeft: isMobile ? 0 : sidebarWidth + SIDEBAR_MARGIN, 
          marginBottom: isMobile ? '94px' : 0,
          transition: 'margin-left 0.3s cubic-bezier(0.4,0,0.2,1)' 
        }}
      >
        <div className={styles.wrapper_header}>
          <WelcomeHeader onLoginClick={handleLoginClick} />
        </div>
        <div className={styles.wrapper_body}>
          <Outlet />
          <h5 className={styles.footerText}>
            Copyright 2025, All Rights Reserved by NCORE
          </h5>
        </div>
      </div>

      <MobileBottomNav 
        onMenuClick={handleMenuClick}
        onPlusClick={handlePlusClick}
        onLoginClick={handleLoginClick}
      />

      <CookieBanner />
    </div>
  );
};

export default MainLayout;
